import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  getPasswordRuleChecks,
  getPasswordStrength,
} from 'shared/validation/passwordValidation';
import './styles.scss';

const strengthLabels = {
  weak: 'Weak',
  fair: 'Fair',
  strong: 'Strong',
};

const PasswordComplexityNotice = ({ password }) => {
  const { t } = useTranslation();
  const strength = getPasswordStrength(password);

  return (
    <div className="PasswordComplexityNotice">
      <div className="PasswordComplexityNotice__title">
        {t('Password must contain:')}
      </div>
      <ul className="PasswordComplexityNotice__list">
        {getPasswordRuleChecks(password).map((rule) => (
          <li
            key={rule.key}
            className={rule.met ? 'PasswordComplexityNotice__rule--met' : ''}
          >
            {t(rule.label)}
          </li>
        ))}
      </ul>
      {strength && (
        <div
          className={`PasswordComplexityNotice__strength PasswordComplexityNotice__strength--${strength}`}
        >
          <div className="PasswordComplexityNotice__strengthBar">
            <span />
            <span />
            <span />
          </div>
          <span>
            {`${t('Password strength')}: ${t(strengthLabels[strength])}`}
          </span>
        </div>
      )}
    </div>
  );
};

PasswordComplexityNotice.propTypes = {
  password: PropTypes.string,
};

PasswordComplexityNotice.defaultProps = {
  password: '',
};

export default PasswordComplexityNotice;
